import axios from "axios";
import appConfig from "../app-config";
const baseurl = appConfig.development.apiBaseUrl

export const LoginAPI = {
    login: (bodyData) =>
        axios.post(`${baseurl}accounts-api/login-api/`, bodyData)
            .then((response) => response.data)
            .catch((error) => error.response),
    logout: (bodyData) =>
        axios.post(`${baseurl}accounts-api/logout-api/`, bodyData)
            .then((response) => response.data)
            .catch((error) => error.response),
    resetPassword: (bodyData) =>
        axios.post(`${baseurl}accounts-api/reset-password-api/`, bodyData)
            .then((response) => response.data)
            .catch((error) => error.response),
}